import { population } from "../constants";

export const positions = {
  Tempe: [1, 1],
  Tonopah: [-5, 0],
  Phoenix: [0, 0],
  Glendale: [-1, 1],
  Marana: [6.5, -4],
  // "Coolidge System": [2, -3],
  // "Casa Grande": [2, -2],
  "Arizona Water Co. (Pinal)": [4, -3],
  Eloy: [5, -3],
  Tucson: [7.5, -5.5],
  "Flowing Wells": [2, -4],
  // "Flowing Wells Irrigation District": [2, -4],
  "Green Valley": [7.5, -7],
  // "Green Valley Domestic Water Improvement District": [3, -4],
  "Metropolitan Domestic Water Improvement District": [7.5, -4.5],
  "Vail Water Co.": [8.5, -6],
  "Oro Valley": [7.50, -3.5],
  Avondale: [-1, 0],
  Goodyear: [-2, -1],
  Scottsdale: [1, 2],
  "Tonto Hills DWID": [2, 2],
  "Chaparral City Water Co.": [2, 1],
  "Rio Verde Utilities": [3, 3],
  Mesa: [2, 0],
  Gilbert: [3, 0],
  "Apache Junction": [4, 0],
  "Arizona Water Co. (Superstition)": [4, 1],
  "Spanish Trail Water Co.": [8.5, -5],
  "Queen Creek": [4, -1],
  "EPCOR (San Tan)": [5, -1],
  Florence: [6, -2],
  Chandler: [2, -1],
  "EPCOR (Paradise Valley)": [1, 3],
  "Cave Creek": [1, 4],
  "Carefree Water Co.": [2, 3],
  Peoria: [-2, 1],
  "EPCOR (Sun City)": [-3, 3],
  "El Mirage": [-3, 2],
  "EPCOR (Sun City West)": [-5, 3],
  Surprise: [-4, 2],
  "Circle City Water Co.": [-6, 3.5],
  "EPCOR (Agua Fria)": [-2, 0],
  "Arizona Water Co. (White Tank)": [-3, 0],
  Buckeye: [-3, 0],
};

export const aliases = {
  "Flowing Wells Irrigation District": "Flowing Wells",
  "Green Valley Domestic Water Improvement District": "Green Valley",
  "Metropolitan Domestic Water Improvement District": "Metro",
  "Vail Water Co.": "Vail Water",
  "Tonto Hills DWID": "Tonto Hills",
  "Chaparral City Water Co.": "Chaparral City",
  "Arizona Water Co. (Pinal)": "Pinal Valley",
  "Arizona Water Co. (Superstition)": "Superstition System",
  "Spanish Trail Water Co.": "Spanish Trail",
  "EPCOR (San Tan)": "San Tan",
  "EPCOR (Paradise Valley)": "Paradise Valley",
  "EPCOR (Sun City)": "Sun City",
  "EPCOR (Sun City West)": "Sun City - West",
  "Circle City Water Co.": "Circle City",
  "EPCOR (Agua Fria)": "Aqua Fria",
  "Arizona Water Co. (White Tank)": "White Tank"
};

export const reverse_aliases = {
  "Flowing Wells": "Flowing Wells Irrigation District",
  "Green Valley": "Green Valley Domestic Water Improvement District",
  "Metro": "Metropolitan Domestic Water Improvement District",
  "Vail Water": "Vail Water Co.",
  "Tonto Hills": "Tonto Hills DWID",
  "Chaparral City": "Chaparral City Water Co.",
  "Pinal Valley": "Arizona Water Co. (Pinal)",
  "Superstition System": "Arizona Water Co. (Superstition)",
  "Spanish Trail": "Spanish Trail Water Co.",
  "San Tan": "EPCOR (San Tan)",
  "Paradise Valley": "EPCOR (Paradise Valley)",
  "Sun City": "EPCOR (Sun City)",
  "Sun City - West": "EPCOR (Sun City West)",
  "Circle City": "Circle City Water Co.",
  "Aqua Fria": "EPCOR (Agua Fria)",
  "White Tank": "Arizona Water Co. (White Tank)"
};

export const decimalRoundHelper = (num, places = 2) => {
  places = Math.pow(10, places);
  return Math.round(num * places) / places;
};

export function calculateLegendLabels(max, min) {
  let percentChange = max - min;

  const difference = percentChange / 4;
  const legendLabels = [decimalRoundHelper(min, 2)];
  let current = decimalRoundHelper(min, 2);
  for (let i = 0; i < 4; i++) {
    legendLabels.push(decimalRoundHelper((current += difference), 2));
  }
  return legendLabels;
}

export function calculateLegendLabelsForBuckets(entitlements_by_year) {
  var { current, difference } = getLegendValuesYellow(entitlements_by_year);
  const legendLabels = [];
  for (let i = 0; i < 5; i++) {
    let nextLevel = decimalRoundHelper(current + difference, 2)
    legendLabels.push(decimalRoundHelper(current, 2)  + "-" + nextLevel);
    current += difference;
  }
  // return legendLabels.reverse();
  // currently using a fixed range. This return value ignores the calculation above.
  return ["0-0.1", "0.11-0.2", "0.21-0.3", "0.31-0.4", "0.41-0.5","0.51+"].reverse();
  // return ["0 to 0.1", "0.11 to 0.2", "0.21 to 0.3", "0.31 to 0.4", "0.41 to 0.5","Greater than 0.51"].reverse();
}

export function createSeries(legendRanges) {
  const series = [];
  const colors = ["#092153", "#1C3874", "#395795", "#8EA5D8", "#C7D7F9"].reverse();
  for (let i = 0; i < legendRanges.length; i++) {
    if (i===0){
      series.push({ data: [], color: colors[i], name: legendRanges[i], bucketRange: "Less than or equal to "+ legendRanges[i]+"%"});
    }
    else{
      series.push({ data: [], color: colors[i], name: legendRanges[i], bucketRange: (legendRanges[i-1]+1)+ "% to "+ legendRanges[i]+"%"});
    }
    
  }
  return series;
}

export function createYellowSeries(legendRanges) {
  const series = [];
  const colors = ["#6A3A00", "#AA5C00", "#D88C31", "#FFB607", "#F5CF66", "#F9E59C"] 


  for (let i = 0; i < legendRanges.length; i++) {
    let lower_upper =  legendRanges[i].split("-");
    if (lower_upper.length === 1) {
      series.push({ data: [], color: colors[i], name: legendRanges[i], bucketRange: "Greater than or equal to "+ lower_upper[0].split("+")[0] });
    }
    else{
      series.push({ data: [], color: colors[i], name: legendRanges[i], bucketRange: lower_upper[0]+" to "+lower_upper[1] });
    }
  }
  return series.reverse(); // Reverse is used since we need the legend to be displayed in desc order
}

export function findIndex(d, legendRanges) {
  return d === legendRanges[0]
    ? 0
    : d <= legendRanges[1]
    ? 1
    : d <= legendRanges[2]
    ? 2
    : d <= legendRanges[3]
    ? 3
    : 4;
}

export function findIndexYellow(alloc, entity_name, legend) {
  const legend_length = legend.length;
  const lower_upper_list = legend.map((range_str)=>{
    let lower_upper = range_str.split("-");
    if (lower_upper.length === 1) {
      lower_upper[0] = lower_upper[0].split("+")[0];
      lower_upper.push('100000') // for 0.51+ bucket, set a huge number as the upper limit.
    }
    return lower_upper
  });
  lower_upper_list.reverse();
  let lower, upper;
  let alloc_by_pop =  decimalRoundHelper(alloc / population[entity_name], 2)

  for (let i = 0; i < legend_length; i++) {
    lower = parseFloat(lower_upper_list[i][0])
    upper = parseFloat(lower_upper_list[i][1])
    if (alloc_by_pop >= lower && alloc_by_pop <= upper) {
      return i;
    };
  }
  // return 4;
}

export const alias_entity_id_mapping = {
  Phoenix: 1,
  "Arizona Water Co. (Superstition)": 2,
  "Arizona Water Co. (Pinal)": 3,
  "Arizona Water Co. (White Tank)": 4,
  Avondale: 5,
  Buckeye: 6,
  "Carefree Water Co.": 7,
  "Cave Creek": 8,
  Chandler: 9,
  "Chaparral City Water Co.": 10,
  "Circle City Water Co.": 11,
  "Green Valley": 12,
  "Del Webb": 13,
  "El Mirage": 14,
  Eloy: 15,
  "EPCOR (Agua Fria)": 16,
  "EPCOR (Paradise Valley)": 17,
  "EPCOR (Sun City)": 18,
  "EPCOR (Sun City West)": 19,
  "EPCOR (San Tan)": 20,
  Florence: 21,
  "Flowing Wells Irrigation District": 22,
  "Flowing Wells": 22,
  Gilbert: 23,
  Glendale: 24,
  Goodyear: 25,
  Marana: 26,
  Mesa: 27,
  "Metropolitan Domestic Water Improvement District": 28,
  "Oro Valley": 29,
  Peoria: 30,
  "Apache Junction": 31,
  "Queen Creek": 32,
  "Rio Verde Utilities": 33,
  Scottsdale: 34,
  "Spanish Trail Water Co.": 35,
  Surprise: 36,
  Tempe: 37,
  "Tonto Hills DWID": 38,
  Tucson: 39,
  "Vail Water Co.": 40,
  Tonopah: 41,
};


function getLegendValuesYellow(entitlements_by_year) {
  let max_co_access = -1;
  let min_co_access = -1;

  for (const [entity_id, value] of Object.entries(entitlements_by_year)) {
    let entity_name;
    for (const [alias_key, alias_value] of Object.entries(alias_entity_id_mapping)) {
      if (alias_value === entity_id) {
        entity_name = alias_key;
        break;
      }
    }

    if (entity_name === undefined) {
      continue;
    }

    let current_entity_total_co_access = value.total_co_access / population[entity_name];
    if (current_entity_total_co_access > max_co_access || max_co_access === -1) {
      max_co_access = current_entity_total_co_access;
    };
    if (current_entity_total_co_access < min_co_access || min_co_access === -1) {
      min_co_access = current_entity_total_co_access;
    };

  }

  // max_co_access = max_co_access;
  let abs_change = max_co_access - min_co_access;

  const difference =  decimalRoundHelper(abs_change / 5, 2);
  let current = decimalRoundHelper(min_co_access, 2);
  return { current, difference };
}

